var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAigHeader = function SvgIconAigHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M18.183 13.14c.09.28.135.57.136.859h4.688c0-.272-.08-.544-.239-.78L15.16 1.93a1.37 1.37 0 0 0-.919-.59q.068.012.135.028z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CCFF",
    d: "m9.818 13.14 3.807-11.773a1.38 1.38 0 0 0-.784.561L5.233 13.22a1.4 1.4 0 0 0-.239.78h4.688c0-.29.046-.58.136-.859"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M9.818 14.86a2.8 2.8 0 0 1-.136-.862H4.994c0 .273.08.547.239.783L12.84 26.07c.226.336.563.527.92.588q-.069-.01-.136-.027z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0850AC",
    d: "M18.318 13.998c0 .291-.045.582-.136.863L14.375 26.63q-.067.017-.135.027c.356-.061.693-.252.92-.588l7.608-11.288c.16-.236.239-.51.238-.783z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E87",
    d: "m14.855 1.928 7.45 11.292c.16.235.239.507.24.779h.462c0-.272-.08-.544-.238-.78L15.16 1.93a1.36 1.36 0 0 0-.781-.552l.047.145c.164.099.312.232.429.406"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M22.544 13.998c0 .273-.079.547-.238.783L14.855 26.07a1.35 1.35 0 0 1-.43.406l-.046.145c.303-.083.585-.26.781-.551l7.608-11.288c.16-.236.24-.51.24-.783z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M9.683 13.999h8.636c0-.29-.046-.58-.136-.859L14.376 1.367a1.5 1.5 0 0 0-.75 0L9.818 13.14c-.09.28-.135.57-.135.859"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#83E2FC",
    d: "M13.848 1.33c-.132.014-.168.026-.223.038L9.819 13.141c-.09.28-.135.569-.135.858h.868c0-.29.045-.579.135-.858z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M18.183 14.86q.136-.422.136-.862H9.683c0 .291.044.582.135.863l3.808 11.769c.226.062.52.063.75 0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3FF",
    d: "M13.848 26.664c-.165-.018-.17-.029-.223-.038L9.819 14.853a2.8 2.8 0 0 1-.135-.859h.868c0 .29.045.58.135.859z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00809E",
    d: "M14.38 1.377h-.001l3.804 11.763c.09.28.136.57.136.859h.592c0-.29-.045-.58-.135-.859z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFF8FF",
    d: "M13.193 1.57a1.4 1.4 0 0 0-.352.36L5.233 13.22a1.4 1.4 0 0 0-.239.78h.804c0-.272.08-.544.239-.78z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M14.38 26.62h-.001l3.804-11.763c.09-.28.136-.57.136-.859h.592c0 .29-.045.58-.135.859z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#85D1FF",
    d: "M13.193 26.428a1.4 1.4 0 0 1-.352-.36l-7.608-11.29a1.4 1.4 0 0 1-.239-.78h.804c0 .272.08.544.239.78z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.23 7.967-4.07-6.039c-.568-.822-1.782-.798-2.319 0L5.896 12.236c6.965.426 11.001-1.652 13.333-4.27",
    opacity: 0.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-header_svg__a)",
    d: "M12.869 10.644a2.436 2.436 0 1 0 0-4.872 2.436 2.436 0 0 0 0 4.871",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-header_svg__b)",
    d: "m13.238 8.4.704.88-.88-.704-.194 1.747-.193-1.747-.88.704.704-.88-1.747-.194 1.747-.194-.705-.88.88.704.194-1.746.194 1.747.88-.705-.704.88 1.747.194z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-header_svg__c)",
    d: "M9.634 19.812a37 37 0 0 0 1.932 2.947 37.4 37.4 0 0 0-3.583-6.07 37 37 0 0 0 1.651 3.123"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-header_svg__d)",
    d: "M15.773 21.714a3.246 3.246 0 1 0 0-6.491 3.246 3.246 0 0 0 0 6.491",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-header_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(12.868 8.207)scale(2.436)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-header_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(12.868 8.206)scale(2.11638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-header_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(15.773 18.468)scale(3.24642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-AIG-header_svg__c",
    x1: 9.053,
    x2: 7.35,
    y1: 17.361,
    y2: 19.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIconAigHeader;